import { isEmpty, omit } from 'lodash';
import { isBrowser } from '@app/utils';

const formatCustomer = (user) => {
  const { Shipping } = user;

  const customer = omit(user, [
    'Billing',
    'CCOnly',
    'Merchant',
    'teamMember',
    'promotionCode',
    'paypalEmails',
    'authorizationMethod',
    'securityOverride',
    'passwordLocked',
    'addressNormalizeOverride',
    'bannedDate',
    'deletedDate',
    'security',
    'earlyPayoutEnabled',
    'earlyPayoutEligible',
    'gotMe',
    'token',
  ]);

  const { locality, region, postalCode, countryCodeAlpha2 } =
    Shipping?.Address || {};

  const categories =
    !isEmpty(customer.categories) &&
    customer.categories.reduce(
      (acc, category) => ({ ...acc, [category]: 1 }),
      {},
    );

  return {
    ...customer,
    categories,
    Address: region
      ? {
          locality,
          region,
          postalCode,
          countryCodeAlpha2,
        }
      : null,
  };
};

export default class googleTagManagerClient {
  static get isReady() {
    return (
      isBrowser && Object.prototype.hasOwnProperty.call(window, 'dataLayer')
    );
  }

  static pushToDataLayer(config) {
    if (!this.isReady) {
      return;
    }

    window.dataLayer.push(config);
  }

  static pageView(url) {
    this.pushToDataLayer({ event: 'pageView', url });
  }

  static legacy(config) {
    this.pushToDataLayer({ ...config, type: 'legacy' });
  }

  static loginSignup(event, user) {
    if (!user) {
      return;
    }

    const customer = formatCustomer(user);
    this.pushToDataLayer({ event, customer });
  }

  static trackCustom(config) {
    this.pushToDataLayer(config);
  }

  static trackTransaction(event, transaction) {
    const config = {
      event,
      emailNotifications: transaction.isGlobalNotificationEmailEnabled,
      ecommerce: {
        purchase: {
          id: transaction.chainId,
          revenue: transaction.amount,
          currency: transaction.localCurrency,
          coupon: transaction?.meta?.discountCode ?? null,
          products: [
            {
              id: transaction.product.uuid,
              name: transaction.product.title,
              brand: transaction.product.brand,
              category: transaction.product.category,
              variant: transaction.product.colorway,
              price: transaction.amount,
              vertical: transaction.product.productCategory,
              imageUrl: transaction.product.media.imageUrl,
              urlKey: transaction.product.urlKey,
              gtin: transaction.product.gtins?.[0]?.identifier_value,
            },
          ],
        },
      },
    };

    this.pushToDataLayer(config);
  }
}
